import { toast } from "react-toastify";

export const toastError = (errorMessage) => {
  return toast.error(errorMessage, {
    position: "top-right",
  });
};

export const toastSuccess = (message) => {
  return toast.success(message, {
    position: "top-right",
  });
};

export const toastWarning = (message) => {
  return toast.warning(message, {
    position: "top-right",
  });
};
